export default __webpack_public_path__ + "static/media/loading.b5920b96.gif";